import clsx from "clsx";
import React, {
  useEffect,
  useRef,
  useState,
  type HtmlHTMLAttributes,
} from "react";

import { OTP_CONFIG } from "@config/auth-config";
import "./resend-code-countdown.scss";
import { milisToText } from "@shared/frontend/functions/milis-to-text.function";
import { useInterval } from "@shared/frontend/hooks/use-interval.hook";

interface ResendCodeCountDownProps
  extends Omit<HtmlHTMLAttributes<HTMLSpanElement>, "children"> {
  onTimeEnd?: VoidFunction;
  onResendCode: VoidFunction;
}

const ResendCodeCountDown: React.FC<ResendCodeCountDownProps> = (props) => {
  const { onResendCode, onTimeEnd, className, ...rest } = props;
  const [timeLeft, setTimeLeft] = useState<string | null>(
    milisToText(OTP_CONFIG.minNewCodeRequestTimeout),
  );
  const countDownEnd = useRef<Date>(getCountDownEnd());

  const interval = useInterval();

  useEffect(() => {
    interval.set(handleInterval, 1000);

    return interval.clear;
  }, []);

  function handleInterval() {
    const timeRemaining = countDownEnd.current.getTime() - Date.now();
    setTimeLeft(timeRemaining > 0 ? milisToText(timeRemaining) : null);
    if (timeRemaining <= 0) {
      interval.clear();
      onTimeEnd?.();
    }
  }

  function getCountDownEnd() {
    return new Date(Date.now() + OTP_CONFIG.minNewCodeRequestTimeout);
  }

  function handleClick() {
    countDownEnd.current = getCountDownEnd();
    setTimeLeft(milisToText(OTP_CONFIG.minNewCodeRequestTimeout));
    interval.clear();
    interval.set(handleInterval, 1000);
    onResendCode();
  }

  return (
    <span className={clsx("resend-code-countdown", className)} {...rest}>
      נשלח אליך קוד האימות בהודעת SMS
      <br />
      <span className="resend-smaller-text">
        {timeLeft !== null ? (
          <>לא קיבלת? ניתן לשלוח קוד אימות נוסף בעוד {timeLeft}</>
        ) : (
          <>
            לא קיבלת? <button onClick={handleClick}>שלחו לי שוב</button>
          </>
        )}
      </span>
    </span>
  );
};

export default ResendCodeCountDown;
